import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-apollo-hooks'
import styled from 'react-emotion'
import { ga, HotelCard, Loader, ModalContainer, Svg } from '../../application'
import EditButton from '../../collections/components/EditButton'
import ManageCollections from '../../collections/components/ManageCollections'
import { colors } from '../../styles'
import * as Queries from '../queries'
import getText from '../strings'

const Heart = styled('span')`
  svg {
    background: #fff linear-gradient(#fff, #f2f2f2);
    color: ${colors.tui_red};
    border: 0;
    padding: 10px;
    border-radius: 4px;
    cursor: pointer;
    position: absolute;
    bottom: 5px;
    right: 5px;
    z-index: 102;
    width: 40px;
    height: 40px;
  }
`

const Hotel = ({ hotel, onManageHotel }) => {
  const [data, setData] = useState(hotel)
  const { loading: loadingFavourites, data: favourite, refetch } = useQuery(Queries.getFavouriteHotel(hotel.id))

  useEffect(() => {
    if (!loadingFavourites && favourite.favouriteHotel) {
      setData({
        ...data,
        priceExample: null,
        isFavourite: favourite.favouriteHotel.isFavourite || favourite.favouriteHotel.collections.length > 0,
      })
    }
  }, [favourite])

  const handleCloseManageHotel = () => {
    refetch()
  }

  const handleOpenManageHotel = (e, tracking) => {
    e && e.preventDefault()
    e && e.stopPropagation()
    tracking && ga.buttonClick(tracking)
    onManageHotel(hotel, handleCloseManageHotel)
  }

  return (
    <HotelCard context="recommendations" key={data.id} hotel={data}>
      {data.isFavourite ? (
        <EditButton context="recommendations" onManageHotel={() => handleOpenManageHotel(null)} />
      ) : (
        <Heart onClick={(e) => handleOpenManageHotel(e, 'recommendations-heart-open-edit-collection')}>
          <Svg icon="heart" />
        </Heart>
      )}
    </HotelCard>
  )
}

const Recommendations = () => {
  const [hotelForManage, setHotelForManage] = useState(null)
  const [closeManageHotelFunction, setCoseManageHotelFunction] = useState(null)
  const { loading, data } = useQuery(Queries.getRecommendations())

  const closeManageCollectionsModal = () => {
    closeManageHotelFunction()
    setHotelForManage(null)
  }

  const showManageCollectionsModal = (hotel, onCloseManageHotel) => {
    setCoseManageHotelFunction(() => onCloseManageHotel)
    setHotelForManage(hotel)
  }

  const manageCollectionsModal = (hotelForManage) => {
    return (
      <ModalContainer width={'800px'} padding={'0px'}>
        <ManageCollections hotel={hotelForManage} onClose={closeManageCollectionsModal} />
      </ModalContainer>
    )
  }

  return (
    <div>
      <h2>{getText('recommendations')}</h2>
      {loading && <Loader />}
      {!loading && data.hotelRecommendations && (
        <div className="hotel-cards-list">
          {data.hotelRecommendations.map((hotel) => (
            <Hotel key={hotel.id} hotel={hotel} onManageHotel={(hotel, func) => showManageCollectionsModal(hotel, func)} />
          ))}
        </div>
      )}
      {hotelForManage !== null && manageCollectionsModal(hotelForManage)}
    </div>
  )
}

export default Recommendations
